module.exports = __webpack_public_path__ + "static/media/rewards-en.61acaa51.jpg";